import React from "react";
import { motion } from "framer-motion";
import { useAuth } from "../../contexts/AuthContext";
import axios from "axios";
import { toast } from "react-toastify";
import {
  FaTrophy,
  FaClock,
  FaExclamationTriangle,
  FaChartLine,
  FaUsers,
  FaBan,
  FaLock,
  FaCheckCircle,
} from "react-icons/fa";

function Stage3({ socketData, canClosePositions }) {
  const { apiBaseUrl } = useAuth();

  const handleCloseAllPositions = () => {
    axios
      .post(
        apiBaseUrl + "/api/user/final/accounts/positions/close",
        {
          target: "groups",
          reason: "five-percent-exceeded",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        // 👇 اینجا API دوم رو call کن
        axios
          .put(
            apiBaseUrl + "/api/tournament/user/five-percent-closed",
            {},
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
          .then((res) => {})
          .catch((err) => {
            console.error("❌ خطا در ثبت five-percent-closed:", err);
          });
      })
      .catch((error) => {
        console.error("❌ خطا در بستن پوزیشن‌ها:", error);
        const errorMessage =
          error.response?.data?.message ||
          "خطا در بستن پوزیشن‌ها. لطفاً دوباره تلاش کنید.";
        toast.error(errorMessage);
      });
  };

  return (
    <div className="h-full flex items-center justify-center p-6 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute rounded-full blur-3xl animate-pulse opacity-20"
          style={{
            width: "500px",
            height: "500px",
            background: canClosePositions
              ? "radial-gradient(circle, #10b981 0%, transparent 70%)"
              : "radial-gradient(circle, #fd0d0e 0%, transparent 70%)",
            top: "20%",
            right: "10%",
            animationDuration: "4s",
          }}
        ></div>
        <div
          className="absolute rounded-full blur-3xl animate-pulse opacity-20"
          style={{
            width: "400px",
            height: "400px",
            background: canClosePositions
              ? "radial-gradient(circle, #10b981 0%, transparent 70%)"
              : "radial-gradient(circle, #fd0d0e 0%, transparent 70%)",
            bottom: "20%",
            left: "10%",
            animationDuration: "5s",
            animationDelay: "1s",
          }}
        ></div>
      </div>

      <div className="max-w-7xl w-full relative z-10">
        {canClosePositions ? (
          // 👇 نمایش دکمه برای کاپیتان تیمی که 5% رو زده
          <motion.div
            className="text-center space-y-8 max-w-2xl mx-auto"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            {/* Success Icon */}
            <motion.div
              className="relative inline-block"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{
                type: "spring",
                stiffness: 200,
                damping: 10,
                delay: 0.2,
              }}
            >
              <div
                className="w-28 h-28 rounded-full mx-auto flex items-center justify-center relative"
                style={{
                  background:
                    "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  boxShadow: "0 10px 40px rgba(16, 185, 129, 0.4)",
                }}
              >
                <FaCheckCircle className="text-white text-6xl" />
              </div>
            </motion.div>

            {/* Title */}
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              <h2 className="text-4xl font-bold text-white mb-2">
                تبریک! هدف محقق شد
              </h2>
              <p className="text-emerald-400 text-xl font-semibold">
                تیم شما به 5% سود رسید
              </p>
            </motion.div>

            {/* Stats Cards */}
            <motion.div
              className="grid grid-cols-2 gap-4"
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              <div
                className="p-4 rounded-xl border"
                style={{
                  backgroundColor: "rgba(16, 185, 129, 0.1)",
                  borderColor: "rgba(16, 185, 129, 0.3)",
                }}
              >
                <div className="flex items-center justify-center gap-2 mb-1">
                  <FaTrophy className="text-emerald-400 text-xl" />
                  <p className="text-white font-bold">تیم برنده</p>
                </div>
                <p className="text-emerald-400 text-sm">شما اولین هستید!</p>
              </div>

              <div
                className="p-4 rounded-xl border"
                style={{
                  backgroundColor: "rgba(16, 185, 129, 0.1)",
                  borderColor: "rgba(16, 185, 129, 0.3)",
                }}
              >
                <div className="flex items-center justify-center gap-2 mb-1">
                  <FaChartLine className="text-emerald-400 text-xl" />
                  <p className="text-white font-bold">سود تیم</p>
                </div>
                <p className="text-emerald-400 text-sm">+5% و بیشتر</p>
              </div>
            </motion.div>

            {/* Close Button */}
            <motion.div
              className="space-y-4"
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
              <button
                onClick={handleCloseAllPositions}
                className="w-full group relative px-8 py-5 text-lg font-bold text-white rounded-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-95"
                style={{
                  background:
                    "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
                  boxShadow: "0 8px 25px rgba(220, 38, 38, 0.4)",
                }}
              >
                <span className="relative flex items-center gap-3 justify-center">
                  <FaLock className="text-xl" />
                  Close All Positions
                </span>
              </button>

              {/* Info Box */}
              <div
                className="p-4 rounded-xl border"
                style={{
                  backgroundColor: "rgba(55, 65, 81, 0.5)",
                  borderColor: "rgba(156, 163, 175, 0.3)",
                }}
              >
                <p className="text-gray-300 text-sm flex items-center gap-2 justify-center">
                  <FaExclamationTriangle className="text-amber-400" />
                  با فشردن این دکمه، تمام پوزیشن‌های همه گروه‌ها بسته می‌شود
                </p>
              </div>
            </motion.div>
          </motion.div>
        ) : (
          // 👇 نمایش توضیحات چالش برای سایرین
          <div className="space-y-5">
            {/* Header */}
            <motion.div
              className="text-center mb-4"
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{
                type: "spring",
                stiffness: 260,
                damping: 20,
                duration: 0.8,
              }}
            >
              <div
                className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-3"
                style={{
                  backgroundColor: "#374151",
                  boxShadow: "0 4px 20px rgba(55, 65, 81, 0.5)",
                }}
              >
                <FaTrophy className="text-white text-4xl" />
              </div>
              <motion.h1
                className="text-4xl font-bold text-white mb-2"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
              >
                مرحله سوم: بیشترین سود در کمترین زمان
              </motion.h1>
              <motion.p
                className="text-red-400 text-lg font-bold"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5 }}
              >
                در این قسمت دو نفر حذف خواهند شد
              </motion.p>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-5">
              {/* Challenge Info */}
              <motion.div
                className="p-5 rounded-2xl backdrop-blur-xl border"
                style={{
                  backgroundColor: "rgba(31, 41, 55, 0.6)",
                  borderColor: "rgba(253, 13, 14, 0.3)",
                }}
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                <div className="flex items-center gap-2 mb-3">
                  <div
                    className="w-8 h-8 rounded-xl flex items-center justify-center"
                    style={{ backgroundColor: "#374151" }}
                  >
                    <FaChartLine className="text-white text-sm" />
                  </div>
                  <h2 className="text-white font-bold text-lg">هدف چالش</h2>
                </div>
                <div className="space-y-2">
                  <p className="text-emerald-400 text-xl font-bold">
                    بیشترین سود در کمترین زمان
                  </p>
                  <div className="flex items-center gap-2 text-gray-300 text-sm">
                    <FaClock className="text-amber-400" />
                    <span>
                      حداکثر زمان: <span className="font-bold">1 ساعت</span>
                    </span>
                  </div>
                  <p className="text-gray-400 text-sm">
                    {" "}
                    ترید روی نماد های مشخص شده برای هر فرد - هر عضو گروه حق یک
                    معامله دارد
                  </p>
                </div>
              </motion.div>

              {/* Drawdown Warning */}
              <motion.div
                className="p-5 rounded-2xl backdrop-blur-xl border"
                style={{
                  backgroundColor: "rgba(31, 41, 55, 0.6)",
                  borderColor: "rgba(253, 13, 14, 0.3)",
                }}
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                <div className="flex items-center gap-2 mb-3">
                  <div
                    className="w-8 h-8 rounded-xl flex items-center justify-center"
                    style={{ backgroundColor: "#374151" }}
                  >
                    <FaExclamationTriangle className="text-white text-sm" />
                  </div>
                  <h2 className="text-white font-bold text-lg">هشدار مهم</h2>
                </div>
                <div className="space-y-2">
                  <p className="text-red-400 font-bold">
                    دراودان حساب گروهی: 10%
                  </p>
                </div>
              </motion.div>
            </div>

            {/* 5% Target */}
            <motion.div
              className="p-5 rounded-2xl backdrop-blur-xl border"
              style={{
                backgroundColor: "rgba(31, 41, 55, 0.6)",
                borderColor: "rgba(253, 13, 14, 0.3)",
              }}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              <div className="flex items-center gap-2 mb-3">
                <div
                  className="w-8 h-8 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: "#374151" }}
                >
                  🎯
                </div>
                <h2 className="text-white font-bold text-lg">تارگت 500 دلار سود</h2>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed mb-3">
                هر تیم سریع‌تر به تارگت 500 دلار سود برسد، دکمه{" "}
                <span className="text-emerald-400 font-bold">
                  Close All Position
                </span>{" "}
                برای کاپیتان آن تیم نمایان می‌شود و تمام معاملات تمام گروه‌ها رو
                می‌بندد
              </p>
              <div
                className="p-3 rounded-xl"
                style={{
                  backgroundColor: "rgba(16, 185, 129, 0.1)",
                  borderRight: "3px solid #10b981",
                }}
              >
                <p className="text-emerald-400 text-sm font-bold">
                  اولین تیمی که به 500 $ سود برسد، برنده می‌شود!
                </p>
              </div>
            </motion.div>

            {/* Winners & Losers */}
            <motion.div
              className="p-5 rounded-2xl backdrop-blur-xl border"
              style={{
                backgroundColor: "rgba(31, 41, 55, 0.6)",
                borderColor: "rgba(253, 13, 14, 0.3)",
              }}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              <div className="flex items-center gap-2 mb-3">
                <div
                  className="w-8 h-8 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: "#374151" }}
                >
                  <FaUsers className="text-white text-sm" />
                </div>
                <h2 className="text-white font-bold text-lg">
                  برندگان و بازندگان
                </h2>
              </div>
              <div className="grid md:grid-cols-2 gap-3">
                <div
                  className="p-3 rounded-xl"
                  style={{
                    backgroundColor: "rgba(16, 185, 129, 0.1)",
                    borderRight: "3px solid #10b981",
                  }}
                >
                  <p className="text-emerald-400 font-bold text-sm mb-1">
                    ✅ برنده
                  </p>
                  <p className="text-gray-300 text-xs">
                    دو تیمی که بیشترین سود را کسب کردند
                  </p>
                </div>
                <div
                  className="p-3 rounded-xl"
                  style={{
                    backgroundColor: "rgba(239, 68, 68, 0.1)",
                    borderRight: "3px solid #ef4444",
                  }}
                >
                  <p className="text-red-400 font-bold text-sm mb-1">
                    ❌ بازنده
                  </p>
                  <p className="text-gray-300 text-xs">
                    دو تیم دیگر - هر تیم بازنده یک نفر حذف می‌شود
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Elimination */}
            <motion.div
              className="p-5 rounded-2xl backdrop-blur-xl border"
              style={{
                backgroundColor: "rgba(31, 41, 55, 0.6)",
                borderColor: "rgba(253, 13, 14, 0.3)",
              }}
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
              <div className="flex items-center gap-2 mb-3">
                <div
                  className="w-8 h-8 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: "#374151" }}
                >
                  <FaBan className="text-white text-sm" />
                </div>
                <h2 className="text-white font-bold text-lg">نحوه حذف</h2>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed">
                نفری که بیشترین ضرر یا کمترین سود را در تیم‌های بازنده کسب کرده
                حذف می‌شود (هر تیم بازنده یک نفر)
              </p>
            </motion.div>

            {/* Final Note */}
            <motion.div
              className="p-4 rounded-2xl backdrop-blur-xl border text-center"
              style={{
                backgroundColor: "rgba(253, 13, 14, 0.1)",
                borderColor: "rgba(253, 13, 14, 0.3)",
              }}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7 }}
            >
              <p className="text-gray-300 text-sm">
                <span className="text-red-400 font-bold">نکته:</span> اگر در طول
                یک ساعت هیچ گروهی تارگت نزد و مسابقه استاپ نشد، پایان وقت
                معاملات توسط استاد آهنگری استاپ خواهد شد و همه معاملات بسته
                می‌شود
              </p>
            </motion.div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Stage3;
